module.exports = "/images/risk-slideshow-1.png?90981446eab6cc7539e948243df41bf9";